import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { TokenService } from "src/app/core/services/token.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { PrintParamsService } from "./prints-params.service";
import { CommonService } from "src/app/core/services/common.service";

@Component({
  selector: "app-maintenance-prints-params",
  templateUrl: "./maintenance-prints-params.component.html",
  styleUrls: ["./maintenance-prints-params.component.sass"],
})
export class MaintenancePrintsParamsComponent implements OnInit {
  printParams;
  constructor(
    private printParamsService: PrintParamsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private tokenService: TokenService,
    private toastrAlertService: ToastrAlertService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.getPrintsParams();
  }
  initForm() {
    this.printParams = new FormGroup({
      glNombre: new FormControl("", [
        Validators.required,
        Validators.maxLength(64),
      ]),
      glValor: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),
    });
  }

  getPrintsParams() {
    this.printParamsService.getPrintParam().subscribe(
      (data) => {
        this.setValues(data);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  setValues(data) {
    this.printParams.patchValue({
      glNombre: data.glNombre,
      glValor: data.glValor,
    });
  }

  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.printParams.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else {
      this.printParamsService
        .updatePrintParam(this.printParams.value)
        .subscribe(
          (data) => {
            this.toastrAlertService.toastrSuccess(data["mensaje"]);
            this.goPredefinedMailBox();
          },
          (err) => {
            this.toastrAlertService.toastrFail(err.error.mensaje);
          }
        );
    }
  }

  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }
}
